import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 发送邮箱验证码
 * @param email 用户邮箱
 * @returns Promise 包含发送结果
 */
export const sendVerificationCode = async (email: string): Promise<{ success: boolean; message: string }> => {
    const apiBaseUrl = getApiBaseUrl();

    try {
        const response = await axios.post(`${apiBaseUrl}/auth/send-code`, {
            email: email.trim()
        });

        // 后端返回 { message: 'Verification code sent' } 表示成功
        // 状态码 200 且有 message 字段表示成功
        if (response.status === 200 && response.data?.message) {
            return {
                success: true,
                message: response.data.message
            };
        }

        return {
            success: false,
            message: response.data?.error || response.data?.message || 'Failed to send verification code'
        };
    } catch (error: any) {
        if (error.response?.data?.error) {
            return {
                success: false,
                message: error.response.data.error
            };
        }
        return {
            success: false,
            message: 'Failed to send verification code. Please try again.'
        };
    }
};

/**
 * 验证邮箱验证码
 * @param email 用户邮箱
 * @param code 验证码
 * @returns Promise 包含验证结果
 */
export const verifyEmailCode = async (email: string, code: string): Promise<{ success: boolean; message: string }> => {
    const apiBaseUrl = getApiBaseUrl();

    try {
        const response = await axios.post(`${apiBaseUrl}/auth/verify-code`, {
            email: email.trim(),
            code: code.trim()
        });

        // 后端返回 { message: 'Email verified successfully' } 表示成功
        if (response.status === 200 && response.data?.message) {
            return {
                success: true,
                message: response.data.message
            };
        }

        return {
            success: false,
            message: response.data?.error || response.data?.message || 'Verification failed'
        };
    } catch (error: any) {
        if (error.response?.data?.error) {
            return {
                success: false,
                message: error.response.data.error
            };
        }
        return {
            success: false,
            message: 'Verification failed. Please try again.'
        };
    }
};
